/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import "./promotional-message-element.module.css";

function PromotionalMessageElement({ element = {}, externalLink }) {
  let text = element.text || "";
  if (externalLink) {
    text = element.text.replace(/<a/g, '<a target="_blank"');
  }
  return (
    <div data-testid="promotional-message" styleName="promotional-message" dangerouslySetInnerHTML={{ __html: text }} />
  );
}

PromotionalMessageElement.propTypes = {
  story: PropTypes.object,
  text: PropTypes.string,
  element: PropTypes.object,
  externalLink: PropTypes.bool
};

export { PromotionalMessageElement };
